import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Tenders IEMs"/>
            
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>Independent External Monitors (IEMs)</h1>
                    </div> 
                    

                    <div className='row'>

                        <div className='col-md-6'>
                            <div className="border m-3">
                                    <div className='mt-3 ms-3'>
                                        <h4 className='mb-3'>Shri Umendra, IFoS</h4>
                                        <ul className='myulcustarrow'>
                                            <li>1/55 C, Vipulkhand, Gomti Nagar<br /> Lucknow – 226010<br />
                                                Email Id: sharmaumendra@gmail.com
                                            </li>
                                        </ul>
                                    </div>
                            </div> 
                        </div>
                        <div className='col-md-6'>
                            <div className="border m-3">
                                        <div className='mt-3 ms-3'>
                                            <h4 className='mb-3'>Shri Ashok Kumar Misra</h4>
                                            <ul className='myulcustarrow'>
                                                <li>A-215, Omaxe City, Bijor Road, Lucknow<br /> Uttar Pradesh – 226025,<br />
                                                    Email Id: ashok2806@gmail.com
                                                </li>
                                            </ul>
                                        </div>
                                </div> 
                            </div>
                        </div>
                    </div>
            </section>
        </>
    )
}

export default Main;